import React, { useEffect, useState } from 'react'
import { injectIntl } from 'react-intl'

import { useWindowWidth } from 'src/hooks/useWindowWidth'
import { Widget } from 'src/components/calendar/Widget'
import { Share } from 'src/components/share'
import { EventReport } from 'src/components/calendar/EventReport'
import { Description } from 'src/components/calendar/Description'
import { EventSection } from 'src/components/calendar/eventSection'
import { AdditionalImages } from 'src/components/calendar/AdditionalImages'
import { Location } from 'src/components/calendar/location'
import { Host } from 'src/components/calendar/host'
import { EventNavigation } from 'src/components/calendar/eventNavigation'
import { Banner } from 'src/components/calendar/Banner'
import { DateAndTime } from 'src/components/calendar/DateAndTime'
import { SingleCalendarWidget } from 'src/components/calendar/SingleCalendarWidget'
import { Interests } from 'src/components/calendar/Interests'
import { EventDisclosure } from 'src/components/calendar/EventDisclosure/EventDisclosure'
import { TicketNav } from 'src/components/calendar/BuyTickets/TicketNav'
import { AttractionsSection } from 'src/components/calendar/AttractionsSection/AttractionsSection'

import { AVAILABILITY_ID } from './constants'
import eventStateModel from './eventStateModel'
/* eslint-disable css-modules/no-unused-class */
import style from './event.css'
import locale from './locale'

const EventComponent = ({
  slug,
  eventData,
  loading,
  intl: { formatMessage },
  isEventSet,
  isTimedEntry,
  eventTimeSlotData,
  ticketButtonText,
  viewer,
}) => {
  const [isEventReported, setIsEventReported] = useState(false)
  const [isBannerDisplayed, setIsBannerDisplayed] = useState(false)

  const { isDesktop, isTablet, isMobile } = useWindowWidth()

  useEffect(() => {
    if (isEventReported) setIsBannerDisplayed(true)
  }, [isEventReported])

  const closeBanner = () => setIsBannerDisplayed(false)

  // listingStatus is not used for Event Sets. Once we move to TimedEntry, we can remove the eventSet logic.
  const listingStatus = isEventSet ? null : eventStateModel(eventData)
  const eventOpen = (
    isEventSet ||
    (eventData &&
      (eventData.totalAvailableTimeSlotCount !== 0)
    )
  )

  const showCalendar = !isEventSet && isTimedEntry && !eventData.soldOut && eventOpen

  return (
    <div className={style.event}>
      <Banner
        isBannerDisplayed={isBannerDisplayed}
        closeBanner={closeBanner}
        message={formatMessage(locale.reportEventMessage)}
      />
      {isDesktop && (
        <EventNavigation
          eventData={eventData}
          loading={loading}
          listingStatus={listingStatus}
          ticketButtonText={ticketButtonText}
          isTimedEntry={isTimedEntry}
          slug={slug}
          isEventReported={isEventReported}
          setIsEventReported={setIsEventReported}
          isEventSet={isEventSet}
          isDesktop={isDesktop}
          viewer={viewer}
        />
      )}

      <div className={style.eventInfo}>
        <div className={style.leftColumn}>
          {!loading && (isMobile || isTablet) && isEventSet && eventData && (
            <EventSection sectionId={AVAILABILITY_ID} heading={formatMessage(locale.availability)}>
              <Widget slug={slug} eventData={eventData} loading={loading} />
              <Share />
              <EventReport
                slug={slug}
                isEventSet={isEventSet}
                isEventReported={isEventReported}
                setIsEventReported={setIsEventReported}
                loading={loading}
                available
              />
            </EventSection>
          )}

          <Description
            loading={loading}
            eventData={eventData}
            isMobile={isMobile}
          />

          {!isEventSet && !isTimedEntry && eventTimeSlotData && (
            <DateAndTime
              loading={loading}
              eventData={eventData}
              eventTimeSlotData={eventTimeSlotData}
              viewer={viewer}
            />
          )}

          {showCalendar && (
            <SingleCalendarWidget
              loading={loading}
              eventData={eventData}
            />
          )}

          <Location
            loading={loading}
            eventData={eventData}
            eventOpen={eventOpen}
          />

          <AttractionsSection
            eventData={eventData}
          />

          {!isEventSet && (
            <AdditionalImages
              loading={loading}
              eventData={eventData}
            />
          )}

          <Host
            isMobile={isMobile}
            loading={loading}
            eventData={eventData}
          />

          <Interests
            loading={loading}
            eventData={eventData}
            isEventSet={isEventSet}
          />

          <EventDisclosure
            loading={loading}
            eventData={eventData}
            isEventSet={isEventSet}
          />

        </div>
      </div>

      {(isMobile || isTablet) && !isEventSet && (
        <TicketNav
          eventData={eventData}
          baseUrl={BASE_URL}
          loading={loading}
          listingStatus={listingStatus}
          ticketButtonText={ticketButtonText}
          isTimedEntry={isTimedEntry}
          viewer={viewer}
        />
      )}
    </div>
  )
}

export const Event = injectIntl(EventComponent)
